import {getRouteApi} from "@tanstack/react-router";

export const materialsRouteApi = getRouteApi("/_app/engineering/materials/");
